import { atom } from 'jotai';
import { selectAtom } from 'jotai/utils';
import { shallowEqual } from 'fast-equals';
import { SIDEBAR_HISTORY_PANE_WIDTH } from '@/common/sidebar/constants.ts';

export type SidebarStackItem = {
  key: string;
  id: string;
  width: number;
  params: Record<string, unknown>;
};

export const sidebarStackAtom = atom<SidebarStackItem[]>([]);
export const currentSidebarItemAtom = selectAtom(
  sidebarStackAtom,
  (sidebarStack) => sidebarStack.at(-1),
  shallowEqual,
);
export const sidebarWidthAtom = selectAtom(sidebarStackAtom, (sidebarStack) => {
  const currentItem = sidebarStack.at(-1);
  if (currentItem === undefined) return 0;
  return (
    currentItem.width + (sidebarStack.length - 1) * SIDEBAR_HISTORY_PANE_WIDTH
  );
});
export const sidebarStackHistoryItem = selectAtom(
  sidebarStackAtom,
  (sidebarStack) => sidebarStack.slice(0, -1),
  shallowEqual,
);
